import { createContext, useContext } from 'react';

/**
 * AdminPageContext
 * --------------------------------------------------------------------
 * Bridges the active <AdminPage /> (which owns the loaded blocks and
 * page metadata for the current slug) with the surrounding
 * <AdminLayout /> (which owns the toolbar Save button + EditModeProvider).
 *
 * The layout registers itself as a consumer of "current page" info, and
 * the page registers itself as a producer when mounted.
 */

const AdminPageContext = createContext({
  registerPage: () => () => {},
  applyBlockChange: () => {},
  getCurrentPage: () => null,
});

export default AdminPageContext;

export function useAdminPageBridge() {
  return useContext(AdminPageContext);
}
